import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { apiError } from "../lib/api";
import RoadmapView from "../components/RoadmapView";
import { Wordmark } from "../components/Layout";
import { Link } from "react-router-dom";

export default function SharePage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/share/${token}`).then(({ data }) => setData(data)).catch((e) => setError(apiError(e)));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#F5F8FF]">
      <header className="border-b border-[#0B1F3A]/10 bg-[#F5F8FF]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
          <Wordmark />
          <Link to="/wizard" className="bg-[#059669] text-white rounded-md px-4 py-2 text-sm font-bold" data-testid="share-header-cta">Map your own project</Link>
        </div>
      </header>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        {error && (
          <div className="text-center py-20">
            <p className="font-serif text-xl text-[#0B1F3A]">{error}</p>
            <Link to="/wizard" className="inline-block mt-4 bg-[#1D4ED8] text-white rounded-md px-5 py-2.5 text-sm font-medium">Generate your own roadmap</Link>
          </div>
        )}
        {!error && !data && <div className="h-64 bg-[#0B1F3A]/10 rounded-xl animate-pulse" />}
        {data && <RoadmapView roadmap={data.roadmap} name={data.name} readOnly />}
      </div>
    </div>
  );
}
